<template>
  <v-overlay
    :value="value"
    :persistent="true"
    :close-on-content-click="false"
    class="align-center justify-center"
  >
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
